import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const hasCarrierServices = {
  name: "hasCarrierServices" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ hasCarrierServices: z.boolean() }),
};
